export enum DATADOG_CONFIG {
  SERVICE_NAME = 'www.ikhokha.com',
  LOG_LEVEL = 'debug',
}
